import { libraryManagedConfig } from '../../config';
import { http } from '../axios';

export const deleteAllProducts = (productGroupId: string) => {
    return http
        .put(
            libraryManagedConfig().endpointProductGroupBulk,
            {},
            {
                pathParams: { productGroupId, kind: 'filter', action: 'remove' }
            }
        )
        .then(res => res.data);
};
